module.exports = __webpack_public_path__ + "img/linkedin.f436d637.svg";